<script>
import Layout from '@/router/layouts/main';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Repositories from '@/repositories';
const ItemsRepository = Repositories.get('items');
import scrollMixin from '@/mixins/scrollWheelMixin';

export default {
  page: {
    title: 'ItemsRequests',
  },
  components: {
    Layout,
    Loading,
  },
  mixins: [scrollMixin],
  data() {
    return {
      isLoading: false,
      items: [
        {
          text: 'itemsRequests',
          href: '/items',
        },
        {
          text: '',
          active: true,
        },
      ],
      inventoryList: [],
      checkedItems: [],
      lastWheelTime: null,
      requestCriticalOnly: false,
      statues: [
        {
          code: 'LOW',
          name: this.$t('general.low'),
          html:
            '<span class="badge badge-warning badge-pill" style="font-size: 1em">' +
            this.$t('general.low') +
            '</span>',
        },
        {
          code: 'CRITICAL',
          name: this.$t('general.critical'),
          html:
            '<span class="badge badge-danger badge-pill" style="font-size: 1em">' +
            this.$t('general.critical') +
            '</span>',
        },
        {
          code: 'GOOD',
          name: this.$t('general.good'),
          html:
            '<span class="badge badge-success badge-pill" style="font-size: 1em">' +
            this.$t('general.good') +
            '</span>',
        },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData(errorArray = []) {
      this.isLoading = true;

      let promise1 = ItemsRepository.getAll().then((response) => {
        let itemsList = response.data.data
          .map((inv) => {
            let {
              totalQuantity: totalQuantity,
              minQuantity: minQuantity,
              reservedQuantity: reservedQuantity,
              orderRequestQuantity: orderRequestQuantity,
              orderedQuantity: orderedQuantity,
              reservedOrderedQuantity: reservedOrderedQuantity,
            } = inv;

            if (totalQuantity < minQuantity) {
              if (
                this.toFloat(
                  totalQuantity -
                    reservedQuantity +
                    orderRequestQuantity +
                    (orderedQuantity - reservedOrderedQuantity)
                ) < minQuantity
              ) {
                inv.status = 'CRITICAL';
              } else {
                inv.status = 'GOOD';
              }
            } else if (
              this.toFloat(totalQuantity - reservedQuantity) < minQuantity
            ) {
              if (
                this.toFloat(
                  totalQuantity -
                    reservedQuantity +
                    orderRequestQuantity +
                    (orderedQuantity - reservedOrderedQuantity)
                ) < minQuantity
              ) {
                inv.status = 'LOW';
              } else {
                inv.status = 'GOOD';
              }
            } else {
              inv.status = 'GOOD';
            }

            let missingOnes = this.toFloat(
              this.toFloat(
                minQuantity -
                  this.toFloat(totalQuantity - reservedQuantity) -
                  this.toFloat(orderedQuantity - reservedOrderedQuantity)
              )
            );

            if (missingOnes < 0) {
              missingOnes = 0;
            }

            inv.toOrder = missingOnes;

            let statusHTMLIndex = this.statues.findIndex(
              (x) => x.code == inv.status
            );
            if (statusHTMLIndex >= 0) {
              inv.statusHTML = this.statues[statusHTMLIndex].html;
            } else {
              inv.statusHTML =
                '<span class="badge badge-danger badge-pill" style="font-size: 1em">' +
                this.$t('general.error').toUpperCase() +
                '</span>';
            }

            let error = errorArray.find((x) => x.idPublic == inv.idPublic);
            if (error != undefined) {
              inv.error = true;
              inv.errorType = error.type;
            } else {
              inv.error = false;
            }

            return inv;
          })
          .filter((x) => x.status != 'GOOD');

        this.inventoryList = itemsList;
        this.checkedItems = [...this.inventoryList.map((inv) => inv.idPublic)];
      });

      Promise.all([promise1])
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        });
    },
    elementSelection(idPublic) {
      let foundIndex = this.checkedItems.findIndex((x) => x == idPublic);
      if (foundIndex < 0) {
        this.checkedItems.push(idPublic);
      } else {
        this.checkedItems.splice(foundIndex, 1);
      }
    },
    wheelItBetter(event, element) {
      element.toOrder = this.scrollMixinEvent(event, element.toOrder, 0);
    },
    requestItems() {
      this.isLoading = true;

      let errorArray = [];

      let payload = this.inventoryList
        .map((i) => {
          if (!this.requestCriticalOnly || i.status == 'CRITICAL') {
            if (i.toOrder >= 0) {
              if (
                i.quantityType == 'decimal' ||
                Number.isInteger(Number(i.toOrder))
              ) {
                return {
                  itemIdPublic: i.idPublic,
                  oldOrderRequestedQuantity: i.orderRequestQuantity,
                  newOrderRequestedQuantity: i.toOrder,
                };
              } else {
                errorArray.push({ idPublic: i.idPublic, type: 'integer' });
              }
            } else {
              errorArray.push({ idPublic: i.idPublic, type: 'negative' });
            }
          }
          return false;
        })
        .filter(
          (x) =>
            x != false &&
            this.checkedItems.includes(x.itemIdPublic) &&
            x.newOrderRequestedQuantity >= 0
        );

      ItemsRepository.actions
        .orderRequests(payload)
        .then(() => {
          this.isLoading = false;
          this.loadData(errorArray);
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.loadData(errorArray);
        });
    },
  },
  computed: {
    inventoryListComputed() {
      if (this.requestCriticalOnly) {
        return this.inventoryList
          .filter((x) => x.status == 'CRITICAL')
          .slice()
          .sort((x, y) => {
            if (x.error == y.error) {
              return 0;
            } else if (x.error) {
              return -1;
            } else {
              return 1;
            }
          });
      } else {
        return this.inventoryList.slice().sort((x, y) => {
          if (x.error == y.error) {
            return 0;
          } else if (x.error) {
            return -1;
          } else {
            return 1;
          }
        });
      }
    },
  },
};
</script>

<template>
  <Layout :title="$t('inventory.inventory')">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div class="container-fluid">
      <b-row class="mb-3">
        <b-col style="display: flex">
          <b-form-checkbox
            id="checkbox-1"
            style="align-self: flex-end"
            v-model="requestCriticalOnly"
            name="checkbox-1"
          >
            {{ $t('items.requestCriticalOnly') }}
          </b-form-checkbox>
        </b-col>
        <b-col></b-col>
        <b-col class="text-right align-bottom">
          <b-button size="md" variant="primary" @click="requestItems()">
            {{ $t('items.requestSelectedItems') }}
            <i class="fas fa-arrow-right"></i>
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <table class="table table-hover">
            <thead class="thead-light">
              <tr>
                <th class="table-row-relative">
                  {{ $t('general.select') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('general.code') }}
                </th>
                <th class="table-row-expandable">
                  {{ $t('general.name') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('general.status') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('items.requested') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('items.ordered') }}
                </th>
                <th
                  class="table-row-relative"
                  style="border-left: 1px solid #f2f2f2"
                >
                  {{ $t('items.reserved') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('items.availables') }}
                </th>
                <th
                  class="table-row-relative"
                  style="border-right: 1px solid #f2f2f2"
                >
                  {{ $t('items.total') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('items.minQuantity') }}
                </th>
                <th class="table-row-relative">
                  {{ $t('categories.category') }}
                </th>
                <th class="table-row-relative" style="min-width: 160px">
                  {{ $t('items.quantityToRequest') }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="element in inventoryListComputed"
                :key="element.idPublic"
                :class="element.error == true ? 'table-danger' : ''"
              >
                <td
                  class="table-row-relative"
                  @click="elementSelection(element.idPublic)"
                >
                  <input
                    :id="element.idPublic"
                    :value="element.idPublic"
                    name="element"
                    type="checkbox"
                    v-model="checkedItems"
                  />
                </td>
                <td class="table-row-relative">{{ element.code }}</td>
                <td class="table-row-expandable">{{ element.name }}</td>
                <td class="table-row-relative" v-html="element.statusHTML"></td>
                <td class="table-row-relative">
                  {{ element.orderRequestQuantity }}
                </td>
                <td class="table-row-relative">
                  {{ element.orderedQuantity }}
                </td>
                <td
                  class="table-row-relative"
                  style="border-left: 1px solid #f2f2f2"
                >
                  {{ element.reservedQuantity }}
                </td>
                <td class="table-row-relative">
                  {{
                    toFloat(element.totalQuantity - element.reservedQuantity)
                  }}
                </td>
                <td
                  class="table-row-relative"
                  style="border-right: 1px solid #f2f2f2"
                >
                  {{ element.totalQuantity }}
                </td>
                <td class="table-row-relative">
                  {{ element.minQuantity }}
                </td>
                <td class="table-row-relative">
                  {{ element.categoryName }}
                </td>
                <td class="table-row-relative" style="min-width: 160px">
                  <b-input
                    id="input-live-feedback"
                    type="number"
                    :state="element.error == true ? false : null"
                    min="0"
                    :step="element.quantityType == 'unitary' ? '1' : '0.00001'"
                    v-model="element.toOrder"
                    @wheel.prevent="wheelItBetter($event, element)"
                  />
                  <b-form-invalid-feedback
                    id="input-live-feedback"
                    class="mt-0"
                    style="margin-bottom: -12px; color: red"
                  >
                    {{
                      $t(
                        element.errorType == 'integer'
                          ? 'errors.noDecimal'
                          : 'errors.noNegative'
                      )
                    }}
                  </b-form-invalid-feedback>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>

<style scoped>
td > input[type='checkbox'] {
  transform: scale(1.5) !important;
  height: 25px !important;
  min-height: 25px !important;
}
td {
  vertical-align: middle;
}
</style>